import type { Modal as ModalAD } from 'antd';
import type { ComponentProps, MouseEventHandler } from 'react';
import { Button } from '../../button';
import { Icon } from '../../icons';
import { Title } from '../../typography';
import styles from './modal-title.module.css';

type P = {
  closable?: ComponentProps<typeof ModalAD>['closable'];
  onCancel?: MouseEventHandler<HTMLButtonElement>;
  title?: ComponentProps<typeof ModalAD>['title'];
};

const ModalTitle = ({ closable, onCancel, title }: P) => {
  if (!closable && !title) {
    return null;
  }

  return (
    <div className={styles['modal-title']}>
      {title ? (
        <Title className={styles.title} level={2}>
          {title}
        </Title>
      ) : null}
      {closable ? (
        <Button
          aria-label="Close modal window"
          icon={<Icon icon="close-line" />}
          onClick={onCancel}
          size="small"
          type="text"
        />
      ) : null}
    </div>
  );
};

export default ModalTitle;
